/* eslint-disable @typescript-eslint/no-unused-vars */
import { settingsCommonStyles } from '../creation-common-styles/settings-common-style';

export const campaignSettingsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .campaign-settings__container': settingsCommonStyles({ palette }),
  '& .dsa-switch-container, & .po-switch-container': {
    '& .checkbox-inline .text': {
      width: 250,
    },
    '& .HelpTopic': {
      marginLeft: 5,
    },
  },
  '& .rsa-auto-assets-setting-container': {
    '& .checkbox-inline': {
      width: '100%',
    },
    '& .HelpTopic': {
      marginLeft: 5,
    },
  },
  '& .feed-product-filter-container': {
    marginTop: 33,
    '& .filter-offset': {
      marginLeft: 25,
    },
  },
  '& .feed-product-filter': {
    '& .all-feed-products': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  '& .broad-only-setting-container': {
    '& .broad-only-setting-radio-content': {
      paddingLeft: 28,
    },
    '& .HelpTopic': {
      marginLeft: 5,
    },
  },
});
